import { RouteCodeEnum } from '@models/menu';
import { Currency } from '@models/system';
import { ContextModule, ContextProgram } from '@system/context/context.model';

export type ContextState = {
  programs: ContextProgram[];
  currencies: Currency[];
  /**
   * The key is the module code. Only CT, P, PRG available.
   */
  modules: Partial<Record<RouteCodeEnum, ContextModule>>;
};

export type ContextPartIds = {
  entityInstanceId?: number;
  no?: string;
};

export type ContextContractIds = ContextPartIds & { contractId?: number };
export type ContextProjectIds = ContextPartIds & { projectId?: number };
export type ContextProgramIds = ContextPartIds & { programId?: number };

export const initialContextState: ContextState = {
  programs: [],
  currencies: [],
  modules: {},
};

export enum ContextStoreActions {
  SetContext = '[Context] Set Context',
}
